import { combineReducers } from "redux";

import AppState from "models/appState";

import auth from "./authReducer";
import supervisor from "./supervisorReducer";
import chat from "./chatReducer";
import pills from "./pillsReducer";
import suggestions from "./suggestionsReducer";
import integration from "./integrationReducer";
import guideReducer from "./guideReducer";
import docReducer from "./docReducer";
import { observerReducer } from "../observer/store/observerReducer";

export default combineReducers<any>({
    auth,
    supervisor,
    chat,
    pills,
    suggestions,
    integration,
    guide: guideReducer,
    doc: docReducer,
    observer: observerReducer,
});
